'use client';

import { AuthenticPlace, UploadFile } from "@/app/lib/generated/graphql-types";
import { useSplitContent } from "@/app/features/shared/split-content/contexts/SplitContentProvider";
import { Button } from "@mui/material";
import { PictureAsPdf } from "@mui/icons-material";
import MediaView from "@/app/features/shared/media-view/ui/public/MediaView.public";
import {
    useAuthenticPlaceEditorContext
} from "@/app/features/sites/authentic-places/contexts/AuthenticPlaceEditorContext";
import { PLACEHOLDER_IMAGE } from "@/app/types/common/constants";
import AuthenticPlacesMiniMap from "@/app/features/sites/authentic-places/ui/shared/AuthenticPlacesMiniMap";
import EditMediaButtonOverlay from "@/app/features/shared/EditMediaButtonOverlay";
import { MediaRef } from "@/app/features/shared/__to_be_integrated/types/general/media/media";

export default function AuthenticPlaceSectionBackgroundEditable({ place }: { place: AuthenticPlace }) {
    const { editable, updateEditable } = useAuthenticPlaceEditorContext();
    const { isHorizontal, isLeading, splitPosition } = useSplitContent();

    const detailsMenuPosition = isHorizontal ? (isLeading ? 'top right' : 'top left') : 'top left';

    function handleImageChange(image: MediaRef | null) {
        if (!image) return;
        updateEditable({
            image
        })
    }

    return (
        <>

            <MediaView
                src={editable?.image || PLACEHOLDER_IMAGE}
                fill
                magnifier="image"
                infoViewType="image"
                detailsMenuPosition={detailsMenuPosition}
                showDetailsMenu
            />
            <AuthenticPlacesMiniMap place={place} />
            <Button
                className="z-[100] bottom-4"
                variant="contained"
                sx={{
                    position: 'absolute',
                    right: isHorizontal && !isLeading ? `calc(${100-splitPosition}% + 16px)` : 16,
                    transition: 'right 0.3s ease'
                }}
                startIcon={<PictureAsPdf/>}
                onClick={() => window.open((place.flyer as UploadFile).url, '_blank')}
            >
                Was steht auf der Tafel?
            </Button>
            <EditMediaButtonOverlay onImageChange={handleImageChange} align={isLeading ? 'right' : 'left'} />
        </>
    )
}
